import { render } from "./VPAAReportsDialog.vue?vue&type=template&id=20007878&scoped=true"
import script from "./VPAAReportsDialog.vue?vue&type=script&lang=js"
export * from "./VPAAReportsDialog.vue?vue&type=script&lang=js"

import "./VPAAReportsDialog.vue?vue&type=style&index=0&id=20007878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20007878"]])

export default __exports__